import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import style from '../style'

const CATEGORY_LIST = ['financial', 'technical', 'other']

const FilterBox = props => {
  const { style, ..._props } = props

  switch (props.type) {
    case 'status':
      return (
        <Container style={style}>
          <Status {..._props} />
        </Container>
      )
    case 'category':
      return (
        <Container style={style}>
          <Category {..._props} />
        </Container>
      )
    case 'date_range':
      return (
        <Container style={style}>
          <DateRange {..._props} />
        </Container>
      )
    default:
      return null
  }
}

const Container = props => (
  <div style={props.style || {}}>
    <div className={css(style.filterbox.box)}>
      <Row>
        <Col>{props.children}</Col>
      </Row>
    </div>
  </div>
)

const Status = props => {
  return [
    <Row
      key={0}
      className={css(style.filterbox.item)}
      onClick={() => props.onChange(-1)}
    >
      <Col
        xs='2'
        className={`d-flex align-items-center justify-content-center`}
      >
        <span
          className={css(
            style.filterbox[props.value === -1 ? 'checkbox_tick' : 'checkbox']
          )}
        />
      </Col>
      <Col>
        <span>all</span>
      </Col>
    </Row>,
    <Row
      key={1}
      className={css(style.filterbox.item)}
      onClick={() => props.onChange(0)}
    >
      <Col
        xs='2'
        className={`d-flex align-items-center justify-content-center`}
      >
        <span
          className={css(
            style.filterbox[props.value === 0 ? 'checkbox_tick' : 'checkbox']
          )}
        />
      </Col>
      <Col>
        <span>resolved</span>
      </Col>
    </Row>,
    <Row
      key={2}
      className={css(style.filterbox.item)}
      onClick={() => props.onChange(1)}
    >
      <Col
        xs='2'
        className={`d-flex align-items-center justify-content-center`}
      >
        <span
          className={css(
            style.filterbox[props.value === 1 ? 'checkbox_tick' : 'checkbox']
          )}
        />
      </Col>
      <Col>
        <span>open</span>
      </Col>
    </Row>
  ]
}

const Category = props => {
  return [
    <Row
      key={0}
      className={css(style.filterbox.item)}
      onClick={() => props.onChange('*')}
    >
      <Col
        xs='2'
        className={`d-flex align-items-center justify-content-center`}
      >
        <span
          className={css(
            props.value.length > 2
              ? style.filterbox['checkbox_tick']
              : style.filterbox['checkbox']
          )}
        />
      </Col>
      <Col>
        <span>all</span>
      </Col>
    </Row>,
    <Row
      key={1}
      className={css(style.filterbox.item)}
      onClick={() => props.onChange(0)}
    >
      <Col
        xs='2'
        className={`d-flex align-items-center justify-content-center`}
      >
        <span
          className={css(
            props.value.includes(0)
              ? style.filterbox['checkbox_tick']
              : style.filterbox['checkbox']
          )}
        />
      </Col>
      <Col>
        <span>{CATEGORY_LIST[0]}</span>
      </Col>
    </Row>,
    <Row
      key={2}
      className={css(style.filterbox.item)}
      onClick={() => props.onChange(1)}
    >
      <Col
        xs='2'
        className={`d-flex align-items-center justify-content-center`}
      >
        <span
          className={css(
            props.value.includes(1)
              ? style.filterbox['checkbox_tick']
              : style.filterbox['checkbox']
          )}
        />
      </Col>
      <Col>
        <span>{CATEGORY_LIST[1]}</span>
      </Col>
    </Row>,
    <Row
      key={3}
      className={css(style.filterbox.item)}
      onClick={() => props.onChange(2)}
    >
      <Col
        xs='2'
        className={`d-flex align-items-center justify-content-center`}
      >
        <span
          className={css(
            props.value.includes(2)
              ? style.filterbox['checkbox_tick']
              : style.filterbox['checkbox']
          )}
        />
      </Col>
      <Col>
        <span>{CATEGORY_LIST[2]}</span>
      </Col>
    </Row>
  ]
}

const DateRange = props => {
  const between = [new Date(props.value[0]), new Date(props.value[1])]

  const _between = [
    {
      month: between[0].toLocaleString('en-us', { month: 'short' }),
      year: between[0].getUTCFullYear()
    },
    {
      month: between[1].toLocaleString('en-us', { month: 'short' }),
      year: between[1].getUTCFullYear()
    }
  ]

  return [
    <Row key={0} className={css(style.filterbox.dateRow)}>
      <Col xs='2'>
        <span
          className={css(
            style.filterbox.dateChange,
            style.filterbox.dateDecrease
          )}
          onClick={() => props.onChange(0, -1)}
        >{`-`}</span>
      </Col>
      <Col xs='8'>
        <span className={css(style.filterbox.date)}>
          {`${_between[0].month} - ${_between[0].year}`}
        </span>
      </Col>
      <Col xs='2'>
        <span
          className={css(
            style.filterbox.dateChange,
            style.filterbox.dateIncreate
          )}
          onClick={() => props.onChange(0, 1)}
        >{`+`}</span>
      </Col>
    </Row>,
    <Row key={1} className={css(style.filterbox.dateRow)}>
      <Col xs='2'>
        <span
          className={css(
            style.filterbox.dateChange,
            style.filterbox.dateDecrease
          )}
          onClick={() => props.onChange(1, -1)}
        >{`-`}</span>
      </Col>
      <Col xs='8'>
        <span className={css(style.filterbox.date)}>
          {`${_between[1].month} - ${_between[1].year}`}
        </span>
      </Col>
      <Col xs='2'>
        <span
          className={css(
            style.filterbox.dateChange,
            style.filterbox.dateIncreate
          )}
          onClick={() => props.onChange(1, 1)}
        >{`+`}</span>
      </Col>
    </Row>
  ]
}

export default FilterBox



// WEBPACK FOOTER //
// ./src/components/Support/partials/FilterBox.js